import { createFileRoute } from "@tanstack/react-router";
import { buildSeo } from "@/lib/seo";
import { HowToPlayPage } from "@/components/HowToPlayPage";
import { lottoAmericaHowToPlayData } from "@/data/how-to-play-lotto-america";
import { buildFaqJsonLd } from "@/lib/faq-jsonld";

export const Route = createFileRoute("/lotto-america/how-to-play")({
  head: () => buildSeo({
    title: "How to Play Lotto America: Rules, Prizes & Odds | USA Lottery Club",
    description: lottoAmericaHowToPlayData.meta.description,
    path: "/lotto-america/how-to-play",
    type: "article",
    jsonLd: buildFaqJsonLd(lottoAmericaHowToPlayData),
  }),
  component: () => <HowToPlayPage {...lottoAmericaHowToPlayData} />,
});